module.exports = __webpack_public_path__ + "static/media/ETH.e9197b6a.jpeg";